(function (root) {
  'use strict';
  function number(value) {
    if (value === '' || value == null || !Number.isFinite(Number(value)) || Number(value) < 0) throw new Error('Invalid price configuration');
    return Number(value);
  }
  function cents(value) { return Math.round((number(value) + Number.EPSILON) * 100); }
  function calculate(pkg, guests, extras, settings) {
    const min = number(settings.min_guests), max = number(settings.max_guests);
    if (!Number.isInteger(guests) || guests < Math.max(1, min) || guests > max) throw new Error('Invalid headcount');
    const included = number(pkg.included);
    if (!Number.isInteger(included)) throw new Error('Invalid included guests');
    const base = cents(pkg.price), guestTotal = Math.max(0, guests - included) * cents(pkg.extra);
    const lines = extras.map(item => ({ id: item.id, title: item.settings.title, amount: cents(item.settings.price) * (item.settings.basis === 'per_guest' ? guests : 1) }));
    const addonTotal = lines.reduce((sum, line) => sum + line.amount, 0);
    const subtotal = base + guestTotal + addonTotal;
    const service = Math.round(subtotal * number(settings.service_rate) / 100);
    // private-event-booking/src/pricing.ts + money.ts: tax on subtotal, rounded to cents.
    const tax = Math.round(((subtotal + (settings.tax_service ? service : 0)) / 100 * number(settings.tax_rate) / 100 + Number.EPSILON) * 100);
    const total = subtotal + service + tax;
    if (!Number.isSafeInteger(total)) throw new Error('Invalid total');
    return { base, guests: guestTotal, addons: addonTotal, subtotal, service, tax, total, each: Math.round(total / guests), lines };
  }
  root.HealthyEventQuoteMath = { calculate };
  if (typeof module !== 'undefined') module.exports = root.HealthyEventQuoteMath;
})(typeof window !== 'undefined' ? window : globalThis);
